export const MAX_NUMBER_OF_GUESTS = 6;
export const BOOKING_TOKEN = 'x-booking-token';
export const PROFILE_BOOKING_DATA = 'profile-booking-data';
export const InitiatedFromEmail = 'initiatedFromEmail';
export const BOOKING_ID_URL = 'bookingId';
export const URL_SOURCE_APP = 'src';
export const MAIN_PROFILE_BOOKING_ID = 'main-booking-id';
export const PROFILE_BOOKINGS = 'profile-bookings';
export const ROOT_PATH = '/reservation';
export const LOCK_UP_PATH = '/reservation/lookup';
export const DASHBOARD_PATH = 'dashboard';
export const PAYMENT_PATH = 'payment';
export const START_PLANNING_PATH = '/booked';
export const START_PLANNING_USA_MARKET_PATH = '/account/cruise-planner';
export const FLIGHTS_CANCELLATION_ROUTE = '/flights/cancellation';
export const FLIGHTS_ROUTE = '/flights/results/departure';
export const FLIGHTS_MANAGE = '/flights/manage';
export const FIND_RESERVATION_PATH = '/account/find-reservation';
export const AMEND_ORIGIN = 'amend-origin';
export const APPLICATION_NAME = 'AMEND';
export const BOOKING_GROUP_TYPE = 'G';
export const GA_PROFILE_BOOKINGS_LENGTH = 'ga-profile-bookings-length';
export const GA_PAGE = '/account';
export const INVALID_NAMES = [
  'TBD',
  'TBA',
  'GUESTONE',
  'GUESTTWO',
  'GUESTTHREE',
  'GUESTFOUR',
  'OTHER',
  'NAME',
];
export const AFFIRM_LOGO =
  'https://www.royalcaribbean.com/content/dam/royal/payment-partners/affirm/affirm_logo_1.png';
export const APPLE_PAY_LOGO =
  'https://www.royalcaribbean.com/content/dam/royal/payment-partners/apple/applepay.svg';

export const flightCtaImage =
  'https://author1.aem.royalcaribbean.com/assetdetails.html/content/dam/royal/special-mkgt/transportation/air-to-sea-airplane-palm-trees-summer.jpg';
export const LOCAL_GRAPH_URI = 'http://localhost:8080/graph';
export const MARKETING_TAGS_URL = 'markets/marketing-tags';

export const FLIGHT_WARNING = 'FLIGHT_WARNING';
export const LOCKED_ERROR = 'BOOKING IS LOCKED';
export const FLIGHT_ERROR = 'FLIGHT_ERROR';
export const PAYMENT_ERROR = 'PAYMENT_ERROR';
export const INCORRECT_SAILING_BOOKING_DATE = 'INCORRECT_SAILING_BOOKING_DATE';
export const BOOKING_STATUS_COURTESY_HOLD = 'BOOKING_STATUS_COURTESY_HOLD';
export const FLIGHT_AGENCY_ERROR = 'FLIGHT_AGENCY_ERROR';
export const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';
export const BOOKING_STATUS_CANCELLED = 'BOOKING_STATUS_CANCELLED';

export const INVALID_SAILING = 'INVALID_SAILING';

export const ERROR_BOOKING_INVALID_TYPE = 'ERROR_BOOKING_INVALID_TYPE';
export const ERROR_BOOKING_INVALID_STATUS = 'InvalidStatus';
export const ERROR_BOOKING_NOT_FOUND = 'BKNG-0017';
export const REPRICE_WARNING = 'REPRICE_WARNING';
export const REPRICE_ERROR = 'REPRICE_ERROR';
export const REPRICE_CRCR_ERROR = 'REPRICE_CRCR_ERROR';
export const ERROR_CODE_LOCKED_BOOKING = 'CSE0098';
export const ERROR_PAYMENT_DECLINED = 'CSE5067';
export const ERROR_BOOKING_FCC_INCOMPLETE = 'IncompleteFCC';
export const SUCCESS_BOOKING_FCC_REDMPTION = 'RedemptionFCC';
export const UNSUCCESSFUL_BOOKING_FCC_REDEMPTION = 'UnsuccessfulRedemptionFCC';
export const FCC_INVALID_STATUS = 'INVALID';
export const FCC_CURRENCY_MISSMATCH = 'CURRENCY_MISSMATCH';
export const FCC_TECHNICAL_ISSUES = 'TECHNICAL_ISSUES';
export const FCC_NAMES_MISSMATCH = 'MISSMATCH';
export const FCC_NON_ELEGIBLE = 'NON_ELEGIBLE';
export const FCC_REDEEMED = 'REDEEMED';
export const FCC_ACTIVE = 'ACTIVE';
export const FCC_SUCCES_NOT_ACTIVE = 'not_active';
export const FCC_CERTIFICATE_EXPIRED = 'EXPIRED';
export const SESSION_STORAGE_AIR_REDIRECT_ERROR = 'air-redirect-error';
export const SESSION_STORAGE_CURRENT_SAILING = 'current-sailing';
export const SESSION_STORAGE_CURRENT_BOOKING = 'current-booking';
export const SESSION_STORAGE_PRICE_BOOKING = 'price-current-booking';
export const SESSION_STORAGE_AUTOMATION_CHANNEL = 'automation-channel';
export const SESSION_STORAGE_INITIATED_FROM_EMAIL = 'initiatedFromEmail';
export const SESSION_STORAGE_GUEST_ACCOUNT_CREATION = 'account-creation';
export const SESSION_STORAGE_CHANGE_FLIGHTS = 'enable-change-flights';
export const SESSION_STORAGE_AVAILABLE_TRANSFERS = 'available-transfers';
export const SESSION_STORAGE_GUEST_ACCOUNT_LOGGED = 'guest-account-logged';
export const SESSION_STORAGE_EXTERNAL_BOOKING = 'external-booking';
export const SESSION_STORAGE_BOOKING_PROFILE = 'booking-profile';
export const SESSION_STORAGE_FLIGHT_TYPE_CODE = 'flight-type-code';

export const RESPONSE_ERROR = 'error';
export const RESPONSE_SUCCESS = 'success';
export const LETTERS_SPACE = /^[A-Za-z\s]*$/;
export const FIRST_NAME_MAX_LENGTH = 14;
export const LAST_NAME_MAX_LENGTH = 17;
export const OUTBOUND = 'OUTBOUND';
export const INBOUND = 'INBOUND';
export const BOOKING_STATUS_BOOKED = 'BOOKED';
export const BOOKING_STATUS_OFFERED = 'OFFERED';
export const BAZIL_MARKET = 'BRA';

export const BOOKING_TYPES = {
  TA: 'TA',
  GRP: 'GRP',
  VP: 'VP',
};

export const REGEX_VALIDATION_CRUISE_CREDIT = /^[0-9]-[A-Z0-9]{1,13}$/;

export const REGEX_VALID_EMAIL_YUP_VALIDATION =
  // eslint-disable-next-line
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;

export const STATEROOM_TYPE_AVIOS = ['BALCONY', 'DELUXE'];
export const FUTURE_CRUISE_CREDIT_TYPES = {
  SUBMITTED: 'SUBMITTED',
  UPDATED: 'UPDATED',
  ACTIVE: 'ACTIVE',
  REDEEMED: 'REDEEMED',
  EXPIRED: 'EXPIRED',
  MISSMATCH: 'MISSMATCH',
  NON_ELEGIBLE: 'NON_ELEGIBLE',
  TECHNICAL_ISSUES: 'TECHNICAL_ISSUES',
  CURRENCY_MISSMATCH: 'CURRENCY_MISSMATCH',
  INVALID: 'INVALID',
};
export const DEFAULT_ITINERARY_TIME = '00:00:00';
export const NAVIGATION_PATHS = [
  {
    login: 'lookup',
    dashboard: 'dashboard',
    default: true,
    payment: 'payment',
    reservation: '/reservation/lookup',
  },
  {
    login: 'future-cruise-credit',
    dashboard: 'future-cruise-credit',
  },
];
export const IMAGES = {
  DEFAULT_PORT_IMAGE:
    'https://assets.dm.rccl.com/is/image/RoyalCaribbeanCruises/royal/special-mkgt/miscellaneous/royal-web-email-booking-reminder.jpg',
  BASE_URL: 'https://assets.dm.rccl.com/is/image/',
  IMAGE_SIZES: [
    { key: '375w', size: '375x205' },
    { key: '768w', size: '635x222' },
    { key: '1024w', size: '704x222' },
    { key: '1440w', size: '932x330' },
  ],
};

export const CC_TYPE = {
  visa: 'VA',
  mastercard: 'MC',
  amex: 'AX',
  dinersclub: 'DC',
  discover: 'DS',
  jsv: 'JC',
};

// Remove comas from strings
export const REMOVE_COMMAS_REGEX = /,/g;
// Only letters
export const ONLY_LETTERS_REGEX = /^[a-zA-Z ]+$/;

// Unified Payment
export const UNIFIED_PAYMENT_SERVICE_BRAND = 'royal';
export const UNIFIED_PAYMENT_SERVICE_CHANNEL = 'ROYAL_WEB_AMEND';
export const UNIFIED_PAYMENT_SERVICE_TYPE = 'CRUISE_BOOKING';
export const UNIFIED_PAYMENT_SERVICE_CLIENT = 'AMEND';
export const UNIFIED_PAYMENT_SERVICE_AUTOMATION_CLIENT = 'ROYAL_WEB_AMEND_TESTING_AUTOMATION';

export const MOCKED_COURTESY_HOLD_TIME = '10:59pm';

export const UPC_PAYMENT_OPTIONS = {
  CREDIT_CARD: 'credit-card',
  GIFT_CARD: 'giftcards',
  AFFIRM: 'affirm',
  PAYPAL: 'paypal',
  APPLE_PAY: 'apple-pay',
  GOOGLE_PAY: 'google-pay',
};
// eslint-disable-next-line
export const SESSION_STORAGE_GDS_INFO = 'info-by-locator';
export const UK_AIR_NUMBER = '044-12312312333';
export const USA_AIR_NUMBER = '1-800-256-6649';
export const AUS_AIR_NUMBER = '061-1231231233';
export const ROUTE_TYPES = {
  ROUND_TRIP: 'Roundtrip',
  ONE_WAY_TRIP: 'One way',
  MULTI_CITY: 'Multi-city',
};
export const LOG_APPLICATION_NAME_PROFILE = 'profile';
export const LOG_APPLICATION_NAME_DIVLINK = 'divlink';
export const COOKIE_KEYS = {
  ACCESS_TOKEN: process.env.REACT_APP_ACCESS_TOKEN_COOKIE_NAME,
  KEEP_ALIVE: 'keepAlive',
  LOYALTY_DATA: 'loyaltyData',
  VDS_ID: 'VDS_ID',
  CH_BOOKING_INFO: 'chBookingInfo',
};

export const FLIGHT_TYPE_CODES = {
  ROUND_TRIP: 'RT',
  ONE_WAY: '1W',
};

export const REDIRECT_API_URL = '/manage/api/v1/bookings/redirect?cipher=';
// TODO: optional market/lang review before launch to prod
export const UNIFIED_MANAGE_URL = '/booked/overview?token=';
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_MARKET = 'USA';
export const TOKEN = 'token';

export const SESSION_EXPIRATION_MODAL_CONFIG = {
  showWarningModal: true,
  showExpiredSessionModal: true,
  minutesToExpiration: 20,
};
